import {
  Grid,
  GridCell,
  Panel,
  SPACING_24,
  SpacingVertical,
  Title,
  TITLE_VARIANT_M
} from 'mailup-web-components'
import { getSenderListInfoDetailsCallback } from 'Pages/Campaign/recoil/callbacks/callbacks'
import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useRecoilCallback } from 'recoil'
import InputSenderReplyTo from './InputReplyTo'
import InputSenderEmail from './InputSenderEmail'
import InputSenderName from './InputSenderName'

export const Sender = () => {
  const intl = useIntl()

  const getSenderListInfoDetails = useRecoilCallback(
    getSenderListInfoDetailsCallback,
    []
  )

  useEffect(() => {
    getSenderListInfoDetails()
  }, [])

  return (
    <>
      <Panel>
        <Title variant={TITLE_VARIANT_M}>
          {intl.formatMessage({ id: 'Load.ContentsCampaignWizard.SenderInfo' })}
        </Title>
        <SpacingVertical variant={SPACING_24} />
        <Grid>
          <GridCell>
            <InputSenderName />
          </GridCell>
          <GridCell>
            <InputSenderEmail />
          </GridCell>
          <GridCell>
            <InputSenderReplyTo />
          </GridCell>
        </Grid>
      </Panel>
    </>
  )
}
